import { fetchWithRetry, handleApiResponse } from "./apis";

const API_URL = "https://chwtgazeif.execute-api.us-east-1.amazonaws.com/default/syncmonitor-api/gpis";

export const getBoxGpiLogs = async (stream, abortController) => {
  try {
    const url = `${API_URL}?sbname=${stream.activesb}`;
    const data = await fetchWithRetry(url, { signal: abortController.signal });

    // Check if the fetch was aborted
    if (abortController.signal.aborted) {
      throw new Error("Fetch aborted");
    }

    // Return the parsed response or an error message if any
    const { apiResponse, errorMsg } = handleApiResponse(data);
    if (errorMsg) {
      return { apiResponse: null, errorMsg };
    }

    return { apiResponse: apiResponse.physGpiVals, errorMsg: null };
  } catch (error) {
    if (error.name === "AbortError") {
      return {
        apiResponse: null,
        errorMsg: "Error fetching GPI logs from Zeam API ... Request aborted",
      };
    }

    return {
      apiResponse: null,
      errorMsg: `Error fetching GPI logs from Zeam API ... ${error.message}`,
    };
  }
};
